import { resolveProfileBackdrop } from '../utils/arena/profileBackdrop';

// A player's profile backdrop bleeding into their row on hover, the
// way Discord's contact list reveals a member's banner. Absolutely
// fills the row, so the row needs `position: relative`, the `group`
// class and `isolation: isolate`: the backdrop sits at z-index -1,
// which under an isolated row paints above the row's own background
// and below all of its unpositioned content. The art fades in via
// `group-hover`.
//
// The art fills the right 62% of the row, never more, and fades out
// at its left edge so the name and rank stay on the plain row; it is
// dimmed a touch so the hover actions on the right stay legible over
// it. The image is scaled to cover that window and cropped, never
// stretched. Capping the window well short of the row keeps the crop from
// degenerating into a hair-thin band on very wide rows. Sites are
// portrait files played sideways, so the image is rotated the same
// way the profile hero rotates it: the window is its own size
// container, which makes `100cqh` / `100cqw` read the window's box
// and lets the pre-rotation dimensions swap without knowing the
// row's size in advance.
// `shown` keeps the art visible without hover, for a selected row.
export default function RowArtBackdrop({ player, sorceryCards, borderRadius, shown = false }) {
  const art = resolveProfileBackdrop(player, sorceryCards);
  if (!art) return null;
  const imageStyle = art.isSite
    ? {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100cqh',
        height: '100cqw',
        objectFit: 'cover',
        transform: 'translate(-50%, -50%) rotate(90deg)',
      }
    : {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center 20%',
      };
  const mask = 'linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.7) 30%, black 100%)';
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 overflow-hidden pointer-events-none group-hover:opacity-100 transition-opacity duration-300 ${shown ? 'opacity-100' : 'opacity-0'}`}
      style={{ borderRadius, zIndex: -1 }}
    >
      <div
        className="absolute top-0 bottom-0 right-0 overflow-hidden"
        style={{ width: '62%', containerType: 'size', maskImage: mask, WebkitMaskImage: mask }}
      >
        <img src={art.url} alt="" draggable={false} loading="lazy" style={{ ...imageStyle, opacity: 0.7 }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(8,6,4,0.1) 0%, rgba(8,6,4,0.45) 100%)' }} />
      </div>
    </div>
  );
}
